import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Avatar, Chip, ListItemButton, ListItemIcon, ListItemText, Typography, Box, Badge } from '@mui/material';
import { updateUnseenMessageCount, fetchMenueStat } from '../store/reducers/menuStat';

const MenuStats = ({ item }) => {
    const dispatch = useDispatch();
    const { registeredUsersCount, unseenMessageCount } = useSelector((state) => {
        return state.menuStat.stats;
    });
    const [canShowStat, setCanShowStat] = useState(false);
    const [statCount, setStatCount] = useState(0);

    useEffect(() => {
        if (item.id === 'registeredUser') {
            setCanShowStat(true);
            setStatCount(registeredUsersCount);
        }
        if (item.id === 'chat') {
            setCanShowStat(true);
            setStatCount(unseenMessageCount);
        }
    }, [item.id, registeredUsersCount, unseenMessageCount]);

    return (
        <>
            {canShowStat && statCount > 0 && (
                <Box sx={{ marginLeft: '1rem' }}>
                    <Badge badgeContent={statCount} color="primary"></Badge>
                </Box>
            )}
        </>
    );
};

export default MenuStats;
